import { createContext } from 'react';
import Predicate from '../../../../../../@Api/Automation/Function/Computation/Predicate/Predicate';

export default createContext<Predicate>(undefined);
